import React from 'react';
import styled from 'styled-components';
import MuiContainer from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import { NextSeo } from 'next-seo';

const Container = styled(MuiContainer)`
  display: flex !important;
  flex-direction: column;
`;

const TermsOfUse = () => {
  return (
    <>
      <NextSeo
        title="Terms of Use"
        description="If you require any more information or have any questions about our site’s disclaimer, please feel free to contact us by email at info@rentable.pk"
        canonical="https://rentable.pk/terms-of-use"
        openGraph={{
          url: 'https://rentable.pk/terms-of-use',
          type: 'basic',
          title: 'Terms of Use',
          description:
            'If you require any more information or have any questions about our site’s disclaimer, please feel free to contact us by email at info@rentable.pk',
          images: [
            {
              url: 'https://rentable.pk/assets/logos/green-text-logo.png',
              alt: 'Rentable Pakistan',
            },
          ],
        }}
      />
      <Container maxWidth="lg">
        <Typography style={{ marginTop: 30 }} variant="h3" color="primary">
          Terms of Use
        </Typography>
        <Typography variant="subtitle1">
          <em>Last updated on 25 December, 2019</em>
        </Typography>
        <Typography variant="h4" style={{ marginTop: 30 }}>
          Acceptance
        </Typography>
        <Typography variant="body1">
          <p>
            Rentable Solutions Pvt Ltd provides a collection of online resources which include
            classified advertisements and forums (collectively, the `&quot;`Service`&quot;`) on the
            website rentable.pk and related sites and the mobile application of the platform
            (collectively, the `&quot;`Website`&quot;`).
          </p>
          <p>
            The Website and the Service are provided to you subject to these Rentable Terms of Use
            (these `&quot;`Terms`&quot;`). For the purpose of the Terms and wherever the context so
            requires, the terms `&apos;`you`&apos;` and “your” shall mean any person who uses the
            Website or the Service in any manner whatsoever including persons browsing the Website
            and its content, posting comments or any content or responding to any advertisements or
            content on the Website. By accessing, browsing or using the Website or Service, you
            agree to comply with these Terms. Additionally, when using a portion of the Service, you
            agree to conform to any applicable posted guidelines for such Service, which may change
            or be updated from time to time at Rentable’s sole discretion. You understand and agree
            that you are solely responsible for reviewing these Terms from time to time. Should you
            object to any term or condition of these Terms, any guideline, or any subsequent changes
            thereto or become unhappy with Rentable or the Service in any way, your only choice is
            to immediately discontinue use of Rentable. These Terms may be updated by Rentable at
            any time at its sole discretion. Rentable may send you notices of changes to the Website
            or the Terms pursuant to Section xxi (I) herein. Rentable may provide a translation of
            the English version of the Terms into other languages. You understand and agree that any
            translation of the Terms into other languages is for your convenience only and that the
            English version governs the terms of your relationship with Rentable. Furthermore, if
            there are any inconsistencies between the English version of the Terms and any
            translation, the English version of the Terms shall govern.
          </p>
        </Typography>
        <Typography variant="h4">Description of Service and Content Policy</Typography>
        <Typography variant="body1">
          <p>
            Rentable is the next generation of free online classifieds. We act as an online
            marketplace platform to allow our users who comply with these Terms to offer, rent, and
            lease products and services listed on the Website. Although you may be able to conduct
            payment and other transactions through the Website, using third-party vendors such as
            PayPal or Stripe, Rentable is not in any way involved in such transactions. As a result,
            and as discussed in more detail in these Terms, you hereby acknowledge and agree that
            Rentable is not a party to such transactions, has no control over any element of such
            transactions, and shall have no liability to any party in connection with such
            transactions. You use the Service and the Website at your own risk.
          </p>
          <p>
            You understand that Rentable does not control, and is not responsible for ads, directory
            information, business listings/information, messages between users, including without
            limitation e-mails sent from outside Rentable’s domain or other means of electronic
            communication, whether through the Website or another Third Party Website (defined
            below) or offerings, comments, user postings, files, images, photos, video, sounds,
            business listings/information and directory information or any other material made
            available through the Website and the Service (`&quot;`Content`&quot;`), and that by
            using the Website and the Service, you may be exposed to Content that is offensive,
            indecent, inaccurate, misleading, or otherwise objectionable. You acknowledge and agree
            that you are responsible for and must evaluate, and bear all risks associated with, the
            use of any Content, that you may not rely on said Content, and that under no
            circumstances will Rentable be liable in any way for the Content or for any loss or
            damage of any kind incurred as a result of the browsing, using or reading any Content
            listed, e-mailed or otherwise made available via the Service. You acknowledge and agree
            that Rentable permits such goods and services to be displayed and offered on the Website
            that conform with the terms stated herein, however Rentable does not pre-screen or
            approve any Content, but that Rentable has the right, in its sole and absolute
            discretion, to refuse, delete or move any Content that is or may be available through
            the Service, for violating these Terms and such violation being brought to Rentable’s
            knowledge or for any other reason or no reason at all. Furthermore, the Website and
            Content available through the Website may contain links to other third party websites
            (`&quot;`Third Party Websites`&quot;`), which are completely unrelated to Rentable. If
            you link to Third Party Websites, you may be subject to those Third Party Websites’
            terms and conditions and other policies. Rentable makes no representation or guarantee
            as to the accuracy or authenticity of the information contained in any such Third Party
            Website, and your linking to any other websites is completely at your own risk and
            Rentable disclaims all liability thereto.
          </p>
          <p>
            You acknowledge and agree that you are solely responsible for your own Content posted
            on, transmitted through, or linked from the Service and the consequences of posting,
            transmitting, linking or publishing it. More specifically, you are solely responsible
            for all Content that you upload, email or otherwise make available via the Service. In
            connection with such Content posted on, transmitted through, or linked from the Service
            by you, you affirm, acknowledge, represent, warrant and covenant that: i) you have
            developed the contents such as description and/or photographs in accordance with the
            instructions and guidance for placing an ad provided by Rentable on the website and that
            any copyrights therein belongs to Rentable and, to any extent, should you be deemed to
            own any copyright you hereby assign any such copyright to Rentable. ii) you acknowledge
            that the information and/or photographs that you post on the Website is stored and
            compiled by Rentable in a proprietary database and that the uploaded information and/or
            photographs are modified by Rentable by applying a watermark of Rentable logo and in
            such derivate works also the copyright belongs to Rentable. iii) you shall continue to,
            for such time the Content is available on the Website, have the necessary licenses,
            authorizations, consents, and permissions to use such Content on the Service and Website
            (including without limitation all patent, trademark, trade secret, copyright or other
            proprietary rights in and to any and all such Content) and wherever required, in such
            cases where you have the right, hereby authorize and license Rentable to exclusively use
            such Content to enable inclusion and use of the Content in the manner contemplated by
            the Service, the Website and these Terms; and iv) you have the written consent, release,
            and/or permission of each and every identifiable individual person or business in the
            Content to use the name or likeness of each and every such identifiable individual
            person or business to enable inclusion and use of the Content in the manner contemplated
            by the Service, the Website and these Terms. For clarity, by submitting any Content on
            the Website, as aforesaid, wherever you retain any ownership rights in the Content, you
            hereby grant to Rentable an irrevocable, non-cancellable, perpetual, worldwide,
            exclusive, royalty-free, sub-licensable, transferable license to use, reproduce,
            distribute, prepare derivative works of, display, and perform the Content in connection
            with the Website and Rentable`&apos;`s (and its successors`&apos;`) business, including
            without limitation for the purpose of promoting and redistributing part or all of the
            Website and Content therein (and derivative works thereof) in any media formats and
            through any media channels now or hereafter known. Furthermore, by you posting Content
            to any public area of the Service, to the extent you retain any ownership of any rights,
            you agree to and do hereby grant to Rentable all exclusive rights necessary to prohibit
            or allow any subsequent aggregation, display, copying, duplication, reproduction, or
            exploitation of the Content on the Service or Website by any party for any purpose
            including the right to initiate legal action in accordance with the copyright and other
            laws of Pakistan. You also hereby grant each user of the Website a non-exclusive license
            to access your Content through the Website. The foregoing license to each user granted
            by you terminates once you or Rentable remove or delete such Content from the Website.
          </p>
          <p>
            Rentable does not endorse any Content or any opinion, statement, recommendation, or
            advice expressed therein, and Rentable expressly disclaims any and all liability in
            connection with user Content. Rentable does not permit copyright infringing activities
            and infringement of intellectual property rights on the Website, and Rentable may, at
            its sole discretion, remove any infringing Content if properly notified in accordance
            with applicable law that such Content infringes on another`&apos;`s intellectual
            property rights. Rentable reserves the right to remove any Content without prior notice.
            Rentable may also terminate a user`&apos;`s access to the Website, if they are
            determined to be a repeat infringer or found to be indulging in any act contrary to
            these Terms. A repeat infringer is a user who has been notified of infringing activity
            more than twice and/or has had a user submission removed from the Website more than
            twice. Further, at its sole discretion, Rentable reserves the right to decide whether
            any Content is appropriate and complies with these Terms.
          </p>
          <p>
            Rentable may provide a video service to you if you upload photographs for your ad. By
            uploading your photographs, not covered by 2(3)(i) or (ii) above, you irrevocably
            license and consent to the exclusive use of your photographs for this service and
            represent and warrant that you have all right, title and interest necessary to upload
            and use the photographs on this service. Under this service, using a third party
            application or service, Rentable may, at its discretion, create a video of your
            photographs, upload the video via www.youtube.com or another third party service
            provider, as determined by Rentable at its discretion, and embed the video into your ad
            on Rentable.
          </p>
        </Typography>
        <Typography variant="h4" style={{ marginTop: 30 }}>
          Featured Ads
        </Typography>
        <Typography variant="body1">
          <p>
            Rentable may offer a service known as `&quot;`Featured Ads`&quot;` where users may pay a
            non-refundable fee to have their ads posted in selected locations on the Website, thus
            potentially increasing an ads`&apos;` visibility. In order to lease a Featured Ad, you
            may be required to transmit certain information through a third party service provider,
            which may be governed by its own terms of use and other policies. Rentable makes no
            representation or guarantee as to the safety or security of the information transmitted
            to any Third Party service provider, and your linking to any Third Party service is
            completely at your own risk, and Rentable disclaims all liability related thereto.
          </p>
          <p>
            Featured Ads are subject to the Terms listed herein, as well as additional terms of
            service.
          </p>
        </Typography>
        <Typography variant="h4" style={{ marginTop: 30 }}>
          Code of Conduct
        </Typography>
        <Typography variant="body1">
          <p>
            You agree not to post, email, host, display, upload, modify, publish, transmit, update
            or share any information on the Site, or otherwise make available Content:
          </p>
          <li>that violates any law or regulation;</li>
          <li>
            that is copyrighted or patented, protected by trade secret or trademark, or otherwise
            subject to third party other intellectual property or proprietary rights, including
            privacy and publicity rights, unless you are the owner of such rights or have permission
            or a license from their rightful owner to post the material and to grant Rentable all of
            the license rights granted herein;
          </li>
          <li>
            that infringes any of the foregoing intellectual property rights of any party, or is
            Content that you do not have a right to make available under any law, regulation,
            contractual or fiduciary relationship(s);
          </li>
          <li>
            that is harmful, abusive, unlawful, threatening, harassing, blasphemous, defamatory,
            obscene, pornographic, pedophilic, libelous, invasive of another`&apos;`s privacy or
            other rights, hateful, or racially, ethnically objectionable, disparaging, relating or
            encouraging money laundering or illegal gambling or harms or could harm minors in any
            way or otherwise unlawful in any manner whatsoever;
          </li>
          <li>
            that harasses, degrades, intimidates or is hateful towards any individual or group of
            individuals on the basis of religion, gender, sexual orientation, race, ethnicity, age,
            or disability;
          </li>
          <li>
            that violates any (local) equal employment laws, including but not limited to those
            prohibiting the stating, in any advertisement for employment, a preference or
            requirement based on race, color, religion, sex, national origin, age, or disability of
            the applicant.
          </li>
          <li>
            that includes personal or identifying information about another person without that
            person`&apos;`s explicit consent;
          </li>
          <li>
            that impersonates any person or entity, including, but not limited to, an Rentable
            employee, or falsely states or otherwise misrepresents an affiliation with a person or
            entity;
          </li>
          <li>
            deceives or misleads the addressee about the origin of such messages or communicates any
            information which is grossly offensive or menacing in nature;
          </li>
          <li>
            that is false, deceptive, misleading, deceitful, misinformative, or constitutes
            `&quot;`bait and switch`&quot;` offer;
          </li>
          <li>
            that constitutes or contains `&quot;`network marketing`&quot;`, `&quot;`multi-level
            marketing`&quot;`, `&quot;`Ponzi and pyramid schemes,`&quot;` `&quot;`affiliate
            marketing,`&quot;` `&quot;`link referral code,`&quot;` `&quot;`junk mail,`&quot;`
            `&quot;`spam,`&quot;` `&quot;`chain letters,`&quot;` or unsolicited advertisements of a
            commercial nature;
          </li>
          <li>
            that constitutes or contains any form of advertising or solicitation if (1) posted in
            areas or categories of the Website which are not designated for such purposes; or (2)
            e-mailed to Rentable users who have requested not to be contacted about other services,
            products or commercial interests;
          </li>
          <li>
            that includes links to commercial services or Third Party Websites, except as
            specifically allowed by Rentable;
          </li>
          <li>
            that advertises any illegal services or the rent of any items the rent of which is
            prohibited or restricted by applicable law, including without limitation items the rent
            of which is prohibited or regulated by applicable law of local jurisdiction;
          </li>
          <li>
            that contains software viruses or any other computer code, files or programs designed to
            interrupt, destroy or limit the functionality of any computer software or hardware or
            telecommunications equipment or any other computer resource;
          </li>
          <li>
            that disrupts the normal flow of dialogue with an excessive number of messages (flooding
            attack) to the Service, or that otherwise negatively affects other users`&apos;` ability
            to use the Service; or
          </li>
          <li>
            that employs misleading email addresses, or forged headers or otherwise manipulated
            identifiers in order to disguise the origin of Content transmitted through the Service.
          </li>
          <p>Additionally, you agree not to:</p>
          <li>
            contact anyone who has asked not to be contacted, or make unsolicited contact with
            anyone for any commercial purpose, specifically, contact any user to post advertisement
            on a third party Website or post any advertisement on behalf of such user; or to
            `&quot;`stalk`&quot;` or otherwise harass anyone;
          </li>
          <li>make any libelous or defamatory comments or postings to or against anyone;</li>
          <li>
            collect personal data about other users or entities for commercial or unlawful purposes;
          </li>
          <li>
            use automated means, including spiders, robots, crawlers, data mining tools, or the like
            to download or scrape data from the Service, except for internet search engines (e.g,.
            Google) and non-commercial public archives (e.g. archive.org) that comply with our
            robots.txt file;
          </li>
          <li>
            post Content that is outside the local area or not relevant to the local area,
            repeatedly post the same or similar Content, or otherwise impose unreasonable or
            disproportionately large loads on our servers and other infrastructure;
          </li>
          <li>
            post the same item or service in multiple classified categories or forums, or in
            multiple metropolitan areas;
          </li>
          <li>
            attempt to gain unauthorized access to computer systems owned or controlled by Rentable
            or engage in any activity that disrupts, diminishes the quality of, interferes with the
            performance of, or impairs the functionality of, the Service or the Website.
          </li>
          <li>
            use any form of automated device or computer program (sometimes referred to as
            `&quot;`flagging tools`&quot;`) that enables the use of Rentable`&apos;`s
            `&quot;`flagging system`&quot;` or other community control systems without each flag
            being manually entered by a human that initiates the flag (an `&quot;`automated flagging
            device`&quot;`), or use any such flagging tool to remove posts of competitors, other
            third parties or to remove posts without a reasonable good faith belief that the post
            being flagged violates these Terms or any applicable law or regulation.
          </li>
          <li>
            use any automated device or software that enables the submission of automatic postings
            on Rentable without human intervention or authorship (an `&quot;`automated posting
            device`&quot;`), including without limitation, the use of any such automated posting
            device in connection with bulk postings, or for automatic submission of postings at
            certain times or intervals; or
          </li>
          <li>
            Any Content uploaded by you shall be subject to relevant laws and may be disabled,
            and/or may be subject to investigation under appropriate laws. Furthermore, if you are
            found to be in non-compliance with the laws and regulations, these terms, or the privacy
            policy of the Site, we may terminate your account/block your access to the Site and we
            reserve the right to remove any non-compliant Content uploaded by you.
          </li>
        </Typography>
        <Typography variant="h4" style={{ marginTop: 30 }}>
          Paid Postings
        </Typography>
        <Typography variant="body1">
          <p>
            Rentable may charge a fee to post Content in some areas of the Service. The fee permits
            certain Content to be posted in a designated area of the Website. Each party posting
            Content to the Service is responsible for said Content and compliance with the Terms.
            Any such fees paid hereunder are non-refundable in the event any Content is removed from
            the Service for violating these Terms.
          </p>
        </Typography>
        <Typography variant="h4" style={{ marginTop: 30 }}>
          Posting Agents
        </Typography>
        <Typography variant="body1">
          <p>
            As used herein, the term `&quot;`Posting Agent`&quot;` refers to a third-party agent,
            service or intermediary that offers to post Content to the Service on behalf of others.
            Rentable prohibits the use of Posting Agents, directly or indirectly, without the
            express written permission of Rentable. In addition, Posting Agents are not permitted to
            post Content on behalf of others, directly or indirectly, or otherwise access the
            Service in order to post Content on behalf of others, except with express written
            permission or license from Rentable.
          </p>
        </Typography>
        <Typography variant="h4" style={{ marginTop: 30 }}>
          License to access the Service
        </Typography>
        <Typography variant="body1">
          <p>
            Rentable grants you a limited, revocable, non-exclusive license to access and use the
            Service for personal use. This license granted herein does not include any of the
            following: (a) access to or use of the Service by Posting Agents; or (b) any collection,
            aggregation, copying, duplication, reproduction, display or derivative use of the
            Service nor any use of data mining, robots, spiders, or similar data gathering and
            extraction tools for any purpose unless expressly permitted by Rentable or as otherwise
            set forth in these Terms. Notwithstanding the foregoing, general purpose internet search
            engines and non-commercial public archives that gather information for the sole purpose
            of displaying hyperlinks to the Service, provided they each do so from a stable IP
            address or range of IP addresses using an easily identifiable agent and comply with our
            robots.txt file, may engage in the activities set forth in (b). For purposes of this
            exception, a `&quot;`general purpose internet search engine`&quot;` does not include a
            website or search engine or other service that specializes in classified listings
            including any subset of classifieds listings such as housing, for rent, jobs, services,
            or personals, or which otherwise provides classified ad listing services. The license
            set forth in this Section permits you to display on your website, or create a hyperlink
            thereto, individual postings on the Service so long as such use is for non-commercial
            and/or news reporting purposes only (e.g., for use in personal blogs or other personal
            online media). If the total number of such postings displayed on or linked to your
            website exceeds ninety nine (99) postings, your use will be considered to be in
            violation of these Terms, unless Rentable expressly grants you permission otherwise. You
            are also permitted to create a hyperlink to the home page of the Website so long as the
            link does not portray Rentable, its employees, affiliates or agents in a false,
            confusing, misleading, derogatory, or otherwise offensive matter. Rentable may offer
            parts of the Service in RSS format for the purpose of embedding individual RSS feeds
            into a personal website or blog, or view postings through third party software news
            aggregators. Rentable permits you to display, excerpt from, and link to any such RSS
            feeds on your personal website or personal blow, provided that (a) your use of the RSS
            feed is for personal, non-commercial purposes only, (b) each title within an RSS feed is
            correctly linked back to the original post on the Service and redirects the user to the
            post when the user clicks on it, (c) you provide, in a conspicuous manner, proper
            attribution to `&apos;`Rentable`&apos;` as the source of the RSS feed, (d) your use or
            display of the RSS feed does not suggest that Rentable promotes or endorses any third
            party causes, opinions, ideas, websites, products or services, (e) you do not
            redistribute the RSS feed, and (f) your use does not overburden or otherwise slow the
            performance of Rentable`&apos;`s systems. Rentable reserves all rights in and to the
            content of any RSS feeds provided through the Service and may terminate any RSS feed at
            any time without notice. Use of the Service beyond the scope of authorized access as set
            forth in these Terms immediately terminates any permission or license granted herein. In
            order to collect, aggregate, copy, duplicate, display or make derivative use of the
            Service or any Content made available via the Service for other purposes (including
            commercial purposes) not stated herein, you must first obtain a license from Rentable.
          </p>
        </Typography>
        <Typography variant="h4" style={{ marginTop: 30 }}>
          Intellectual Property Rights
        </Typography>
        <Typography variant="body1">
          <p>
            You acknowledge and agree that the materials on the Website, (other than the user
            Content that you licensed to Rentable under Section 2(3) of the Terms), including
            without limitation, the text, software, scripts, graphics, photos, sounds, music,
            videos, interactive features and the like (`&quot;`Materials`&quot;`) and the
            trademarks, service marks and logos contained therein (`&quot;`Marks`&quot;`), are owned
            by or licensed to Rentable, and are subject to copyright and other intellectual property
            rights under the Pakistani laws and international treaties and/or conventions. In
            connection with the Services, the Website may display certain trademarks belonging to
            third parties. Use of these trademarks may be subject to license granted by third
            parties to Rentable. You shall, in no event, reverse engineer, decompile, or disassemble
            such trademarks and nothing herein shall be construed to grant you any right in relation
            to such trademarks. Materials on the Website are provided to you AS IS for your
            information and personal use only and may not be used, copied, reproduced, distributed,
            transmitted, broadcast, displayed, sold, licensed, or otherwise exploited for any other
            purposes whatsoever without the prior written consent of the respective owners. Rentable
            reserves all rights not expressly granted herein to the Website and the Materials. You
            agree to not engage in the use, copying, reproduction or distribution of any of the
            Materials other than as expressly permitted herein, including any use, copying, or
            distribution of Materials of third parties obtained through the Website for any
            commercial purposes. If you download or print a copy of the Materials for personal use,
            you must retain all copyright and other proprietary notices contained therein. You agree
            not to circumvent, disable or otherwise interfere with security related features of the
            Website or features that prevent or restrict use or copying of any Materials or enforce
            limitations on use of the Website or the Materials therein. The Service is protected to
            the maximum extent permitted by copyright laws, other laws of Pakistan, and
            international treaties and/or conventions. Content displayed on or through the Service
            is protected by copyright including but not limited to as a literary work, a collective
            work and/or compilation, pursuant to copyrights laws, other laws of Pakistan, and
            international treaties and conventions. Any reproduction, modification, creation of
            derivative works from or redistribution of the Website, the Materials, or the collective
            work or compilation, or allowing others to do so, is expressly prohibited. Copying or
            reproducing the Website, the Materials, or any portion thereof to any other server or
            location for further reproduction or redistribution is expressly prohibited. You further
            agree not to reproduce, duplicate or copy Content or Materials from the Service, and
            agree to abide by any and all copyright notices and other notices displayed on the
            Service. You may not decompile or disassemble, reverse engineer or otherwise attempt to
            discover any source code contained in the Service. Without limiting the foregoing, you
            agree not to reproduce, duplicate, copy, sell, resell or exploit for any commercial
            purposes, any aspect of the Service. Rentable is a service mark registered with the U.S.
            Patent and Trademark Office, the EU-wide patent and trademark authorities and in various
            other jurisdictions including Pakistan.
          </p>
        </Typography>
        <Typography variant="h4" style={{ marginTop: 30 }}>
          User submissions
        </Typography>
        <Typography variant="body1">
          <p>
            You understand that when using the Website, you will be exposed to Content from a
            variety of sources, and that Rentable is not responsible for the accuracy, usefulness,
            safety, or intellectual property rights of or relating to such Content, and you agree
            and assume all liability for your use. You further understand and acknowledge that you
            may be exposed to Content that is inaccurate, offensive, indecent, or objectionable,
            defamatory or libelous and you agree to waive, and hereby do waive, any legal or
            equitable rights or remedies you have or may have against Rentable with respect thereto.
          </p>
        </Typography>
        <Typography variant="h4" style={{ marginTop: 30 }}>
          Indemnity
        </Typography>
        <Typography variant="body1">
          <p>
            You agree to defend, indemnify and hold harmless Rentable, its officers, subsidiaries,
            affiliates, successors, assigns, directors, officers, agents, service providers,
            suppliers and employees, from and against any and all claims, damages, obligations,
            losses, liabilities, costs or debt, and expenses (including but not limited to
            attorneys`&apos;` fees) arising from: (i) your use of and access to the Website and/or
            the Service; (ii) your violation of any term of these Terms; (iii) your violation of any
            third party right, including without limitation any copyright, trademark, and other
            intellectual property rights, trade secret or other property, or privacy right; or (iv)
            any claim that your Content caused damage to a third party. This defense and
            indemnification obligation will survive termination, modification or expiration of these
            Terms and your use of the Service and the Website.
          </p>
        </Typography>
        <Typography variant="h4" style={{ marginTop: 30 }}>
          No SPAM Policy
        </Typography>
        <Typography variant="body1">
          <p>
            You understand and agree that sending unsolicited email advertisements or other
            unsolicited communications to Rentable email addresses or through Rentable computer
            systems are expressly prohibited by these Terms. You acknowledge and agree that from
            time to time Rentable may monitor email usage using human monitors or automated software
            to flag certain words associated with spam or scams in emails that are sent between one
            user to another in the Rentable e mail system. Any communication between yourself and
            any other user utilizing the communication features available on the Service and the
            Website may be used only in accordance with the Terms. Any unauthorized use of Rentable
            computer systems is a violation of these Terms and certain applicable laws. Such
            violations may subject the sender and his or her agents to civil and criminal
            liabilities and penalties.
          </p>
        </Typography>
        <Typography variant="h4" style={{ marginTop: 30 }}>
          Dealings with organizations and individuals
        </Typography>
        <Typography variant="body1">
          <p>
            You acknowledge and agree that Rentable shall not be liable for your interactions with
            any organizations and/or individuals on the Website or through the Service. This
            includes, but is not limited to, payment and delivery of goods and services, and any
            other terms, conditions, warranties or representations associated with any interaction
            you may have with other organizations and/or individuals. These dealings are solely
            between you and such organizations and/or individuals. You agree and acknowledge that
            Rentable shall not be responsible or liable for any loss or damage of any sort incurred
            as the result of any such dealings or interactions. If there is a dispute between
            participants on the Website, or between users and any third party, you understand and
            agree that Rentable is under no obligation to become involved in such dispute. In the
            event that you have a dispute with one or more other users, you hereby release Rentable,
            its officers, employees, agents and successors from any and all claims, demands and
            damages (actual and consequential) of every kind or nature, known or unknown, suspected
            and unsuspected, disclosed and undisclosed, arising out of or in any way related to such
            disputes and/or our Service.
          </p>
        </Typography>
        <Typography variant="h4" style={{ marginTop: 30 }}>
          Limitation and Termination fo Services
        </Typography>
        <Typography variant="body1">
          <p>
            You acknowledge and agree that Rentable may establish limits from time to time
            concerning use of the Service, including among others, the maximum number of days that
            Content will be maintained or retained by the Service, the maximum number and size of
            postings, e-mail messages, or other Content that may be transmitted or stored by the
            Service, and the frequency with which you may access the Service or the Website. You
            acknowledge and agree that Rentable has no responsibility or liability for the deletion
            or failure to store any Content maintained or transmitted by the Website or the Service.
            You acknowledge and agree that Rentable reserves the right at any time to modify or
            discontinue the Service (or any part thereof) with or without notice, and that Rentable
            shall not be liable to you or to any third party for any such modification, suspension
            or discontinuance of the Service. You acknowledge and agree that Rentable, in its sole
            and absolute discretion, has the right (but not the obligation) to delete or deactivate
            your account, block your e-mail or IP address, or otherwise terminate your access to or
            use of the Service (or any part thereof), immediately and without notice, and remove and
            discard any Content within the Service, for any reason or no reason at all, including,
            without limitation, if Rentable believes that you have violated these Terms. Further,
            you agree that Rentable shall not be liable to you or any third-party for any
            termination of your access to the Website or the Service. Further, you agree not to
            attempt to use the Service after any such termination.
          </p>
        </Typography>
        <Typography variant="h4" style={{ marginTop: 30 }}>
          Disclaimer of Warranties
        </Typography>
        <Typography variant="body1">
          <p>
            YOU EXPRESSLY ACKNOWLEDGE AND AGREE THAT USE OF THE WEBSITE AND THE SERVICE IS ENTIRELY
            AT YOUR OWN RISK AND THAT THE WEBSITE AND THE SERVICE ARE PROVIDED ON AN `&quot;`AS
            IS`&quot;` OR `&quot;`AS AVAILABLE`&quot;` BASIS, WITHOUT ANY WARRANTIES OF ANY KIND.
            ALL EXPRESS AND IMPLIED WARRANTIES, INCLUDING, WITHOUT LIMITATION, THE WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT OF PROPRIETARY
            RIGHTS ARE EXPRESSLY DISCLAIMED TO THE FULLEST EXTENT PERMITTED BY LAW. TO THE FULLEST
            EXTENT PERMITTED BY LAW Rentable, ITS OFFICERS, DIRECTORS, EMPLOYEES, AND AGENTS
            DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, IN CONNECTION WITH THE WEBSITE AND YOUR USE
            THEREOF. Rentable MAKES NO WARRANTIES OR REPRESENTATIONS ABOUT THE ACCURACY OR
            COMPLETENESS OF THE WEBSITE`&apos;`S CONTENT OR THE CONTENT OF ANY THIRD PARTY WEBSITES
            LINKED TO THE WEBSITE AND ASSUMES NO LIABILITY OR RESPONSIBILITY FOR ANY (I) ERRORS,
            MISTAKES, OR INACCURACIES OF CONTENT, (II) PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY
            NATURE WHATSOEVER, RESULTING FROM YOUR ACCESS TO AND USE OF THE WEBSITE AND SERVICE,
            (III) ANY UNAUTHORIZED ACCESS TO OR USE OF OUR SERVERS AND/OR ANY AND ALL PERSONAL
            INFORMATION AND/OR FINANCIAL INFORMATION STORED THEREIN, (IV) ANY INTERRUPTION OR
            CESSATION OF TRANSMISSION TO OR FROM THE WEBSITE, (IV) ANY BUGS, VIRUSES, TROJAN HORSES,
            OR THE LIKE WHICH MAY BE TRANSMITTED TO OR THROUGH THE WEBSITE BY ANY THIRD PARTY,
            AND/OR (V) ANY ERRORS OR OMISSIONS IN ANY CONTENT OR FOR ANY LOSS OR DAMAGE OF ANY KIND
            INCURRED AS A RESULT OF THE USE OF ANY CONTENT POSTED, EMAILED, COMMUNICATED,
            TRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA THE WEBSITE OR THE SERVICE. Rentable DOES
            NOT WARRANT, ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY PRODUCT OR SERVICE
            ADVERTISED OR OFFERED BY A THIRD PARTY THROUGH THE WEBSITE OR ANY HYPERLINKED WEBSITE OR
            FEATURED IN ANY BANNER OR OTHER ADVERTISING, AND Rentable WILL NOT BE A PARTY TO OR IN
            ANY WAY BE RESPONSIBLE FOR MONITORING ANY TRANSACTION BETWEEN YOU AND/OR OTHER USERS
            AND/OR THIRD-PARTY PROVIDERS OF PRODUCTS OR SERVICES. AS WITH THE lease OF A PRODUCT OR
            SERVICE THROUGH ANY MEDIUM OR IN ANY ENVIRONMENT, YOU SHOULD USE YOUR BEST JUDGMENT AND
            EXERCISE CAUTION WHERE APPROPRIATE.
          </p>
        </Typography>
        <Typography variant="h4" style={{ marginTop: 30 }}>
          Limitation of Liability
        </Typography>
        <Typography variant="body1">
          <p>
            IN NO EVENT SHALL Rentable, ITS OFFICERS, DIRECTORS, EMPLOYEES, OR AGENTS, BE LIABLE FOR
            DIRECT, INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR EXEMPLARY DAMAGES (EVEN IF
            Rentable HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES), RESULTING FROM ANY ASPECT
            OF YOUR USE OF THE WEBSITE OR THE SERVICE, INCLUDING WITHOUT LIMITATION WHETHER THE
            DAMAGES ARISE FROM USE OR MISUSE OF THE WEBSITE OR THE SERVICE, FROM INABILITY TO USE
            THE WEBSITE OR THE SERVICE, OR THE INTERRUPTION, SUSPENSION, MODIFICATION, ALTERATION,
            OR TERMINATION OF THE WEBSITE OR THE SERVICE. SUCH LIMITATION OF LIABILITY SHALL ALSO
            APPLY WITH RESPECT TO DAMAGES INCURRED BY REASON OF OTHER SERVICES OR PRODUCTS RECEIVED
            THROUGH OR ADVERTISED IN CONNECTION WITH THE WEBSITE OR THE SERVICE OR ANY LINKS ON THE
            WEBSITE, AS WELL AS BY REASON OF ANY INFORMATION, OPINIONS OR ADVICE RECEIVED THROUGH OR
            ADVERTISED IN CONNECTION WITH THE WEBSITE OR THE SERVICE OR ANY LINKS ON THE Rentable
            SITE. THESE LIMITATIONS SHALL APPLY TO THE FULLEST EXTENT PERMITTED BY LAW. YOU
            SPECIFICALLY ACKNOWLEDGE AND AGREE THAT Rentable SHALL NOT BE LIABLE FOR USER
            SUBMISSIONS OR THE DEFAMATORY, OFFENSIVE, OR ILLEGAL CONDUCT OF ANY USER OR THIRD PARTY
            AND THAT THE RISK OF HARM OR DAMAGE FROM THE FOREGOING RESTS ENTIRELY WITH YOU. The
            Website is controlled and offered by Rentable. Rentable makes no representations or
            warranties that the Website is appropriate for use in other locations. Those who access
            or use the Website from other jurisdictions do so at their own volition and risk and are
            responsible for compliance with local law.
          </p>
        </Typography>
        <Typography variant="h4" style={{ marginTop: 30 }}>
          Assignment
        </Typography>
        <Typography variant="body1">
          <p>
            These Terms, and any rights and licenses granted hereunder, must not be transferred or
            assigned by you, but may be assigned by Rentable without restriction. Any assignment or
            transfer by you shall be null and void.
          </p>
        </Typography>
        <Typography variant="h4" style={{ marginTop: 30 }}>
          Ability to Accept Terms of Service
        </Typography>
        <Typography variant="body1">
          <p>
            This Website is intended only for adults and that you are eligible to contract as per
            applicable laws. If you are using/accessing this Website as a representative of any
            person/entity, you acknowledge that you are legally authorized to represent that
            person/entity. Minors, i.e. users of under 18 years of age, are only allowed to access
            the Website and use the Service, in the event of approval of their legal representatives
            or in the event that it concerns an act or a transaction that is usual and acceptable
            standard in civil life and practice. You affirm that you are either at least 18 years of
            age, or an emancipated minor, or possess legal parental or guardian consent, and are
            fully able and competent to enter into the terms, conditions, obligations, affirmations,
            agreements, representations, and warranties set forth in these Terms, and to abide by
            and comply with these Terms. In any case, you affirm that you are over the age of 13, as
            the Website is not intended for children under 13.
          </p>
          <p>
            NOTICE TO CHILDREN UNDER THE AGE OF 13 AND THEIR PARENTS OR GUARDIANS If you are under
            the age of 13, YOU MUST NOT USE THIS WEBSITE. Please do not send us your personal
            information, including your email addresses, name, and/or contact information. If you
            want to contact us, you may only do so through your parent or legal guardian.
          </p>
        </Typography>
        <Typography variant="h4" style={{ marginTop: 30 }}>
          General Information
        </Typography>
        <Typography variant="body1">
          <p>
            These Terms and the other policies posted on the Website constitute the complete and
            exclusive understanding and agreement between you and Rentable and govern your use of
            the Service and the Website superseding all prior understandings, proposals, agreements,
            negotiations, and discussions between the parties, whether written or oral. The Terms
            and the relationship between you and Rentable shall be governed by the laws of Pakistan.
            Any claim you may have against Rentable must be submitted to the exclusive jurisdiction
            of the courts of Lahore, Pakistan. However, in the event that you are a consumer it may
            be that consumer law requires that another law is applicable and that a claim may be
            submitted to another jurisdiction. The failure of Rentable to exercise or enforce any
            right or provision of the Terms shall not constitute a waiver of such right or
            provision. If any provision of the Terms is found by a court of competent jurisdiction
            to be invalid (including, without limitation, because such provision is inconsistent
            with the laws of another jurisdiction) or inapplicable, the parties nevertheless agree
            that the court should endeavor to give effect to the parties`&apos;` intentions as
            reflected in the provision. If any provision or provisions of these Terms is held to be
            invalid, illegal or unenforceable, the validity, legality and enforceability of the
            remaining provisions of the Terms shall not in any way be affected or be impaired. These
            Terms shall inure to the benefit of and be binding upon each party`&apos;`s successors
            and assigns.
          </p>
        </Typography>
        <Typography variant="h4" style={{ marginTop: 30 }}>
          Violation of Terms and Liquidated Damages
        </Typography>
        <Typography variant="body1" style={{ marginBottom: 40 }}>
          <p>
            Please report any violations of the Terms that you become aware of by contacting us
            using the link at the bottom of the Rentable homepage at Rentable.com.pk. Any failure to
            act by Rentable with respect to a breach by you or others does not waive our right to
            act with respect to subsequent or similar breaches by you or others. Notwithstanding the
            aforesaid clauses regarding any other provision of these Terms, Rentable retains the
            right to seek legal and equitable remedies, including without limitation, specific
            performance of any term contained in these Terms, or a preliminary or permanent
            injunction against the breach or threatened breach of any such term or in aid of the
            exercise of any power granted in these Terms, or any combination thereof, without the
            necessity of posting a bond.
          </p>
        </Typography>
      </Container>
    </>
  );
};

export default TermsOfUse;
